export default "__VITE_ASSET__CSqivsZw__"